"use client";

import { FC, useContext, useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";

import { useStyles } from "./styles";
import { GenerationPageResponse } from "@/types/thread";
import { useAppSelector, useAppDispatch } from "@/redux/store";
import { setSelectedGeneration } from "@/redux/actions";
import { HistoryContext } from "@/context/HistoryContext";
import BackButton from "@/components/common/BackButton";
import GenSummary from "@/components/gen/GenSummary";
// import DynamicAd from "@/components/adverts/DynamicAd";
// import MonumetricAd from "@/components/adverts/MonumetricAd";
import ExploreGallery from "@/components/gen/ExploreGallery";

interface GenPageContentProps {
  data: GenerationPageResponse;
}

const GenPageContent: FC<GenPageContentProps> = ({ data }) => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const router = useRouter();
  const pathname = usePathname() as string;
  const { history, setHistory } = useContext(HistoryContext);
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user.subscriptionType !== "free");

  const handleBack = () => {
    dispatch(setSelectedGeneration(data.id));
    // Only remove previous path if it's not the same as the current path
    // (changing selected image changes query param part of path)
    if (history.length > 0 && history[history.length - 1] !== pathname) {
      setHistory(history.slice(0, history.length - 1));
    }
    router.back();
  };

  useEffect(() => {
    const main = document.querySelector("main");
    if (!main) return;
    main.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={classes.container}>
      {/* <div className={classes.adContainer}>
        <DynamicAd variant="header-in-screen" className={classes.contentAd} />
      </div> */}
      {history.length > 1 && (
        <BackButton onBack={handleBack} className={classes.backButton} />
      )}
      <div className={classes.content}>
        <GenSummary data={data} />
        {!isSubscribed && (
          <div className={classes.adPillarRight}>
            {/* <MonumetricAd variant="pillar-right" /> */}
          </div>
        )}
      </div>
      <div className={classes.exploreRelated}>
        <h2 className={classes.title}>Explore Related</h2>
        <ExploreGallery
          generationId={data.id}
          galleryImages={data.relatedGenerationsResp.generations}
          initialRemainingGenIds={data.relatedGenerationsResp.remainingGenIds}
        />
      </div>
    </div>
  );
};

export default GenPageContent;
